module.exports = __webpack_public_path__ + "img/18.ff6d040.png";